module.exports = "<h1>Not found!</h1>"


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/pages/not-found/not-found.component.html
// module id = ../../../../../src/app/pages/not-found/not-found.component.html
// module chunks = 39